import { FirstPage } from "./FirstPage";
import { SecondPage } from "./SecondPage";
import { ThirdPage } from "./ThirdPage";
import { LastPage } from "./LastPage";
import { FourthPage } from "./FourthPage";
import { FifthPage } from "./FifthPage";
import { SixthPage } from "./SixthPage";

export const PAGE = {
	FIRST: "first",
	SECOND: "second",
	THIRD: "third",
	FOURTH: "fourth",
	FIFTH: "fifth",
	SIXTH: "sixth",
	LAST: "last",
};

export const TitleMapper = {
	[PAGE.FIRST]: "Lesson Details",
	[PAGE.SECOND]: "Student Performance",
	[PAGE.THIRD]: "Learning Objectives",
	[PAGE.FOURTH]: "Additional Comments",
	[PAGE.FIFTH]: "Questions Asked",
	[PAGE.SIXTH]: "Resource uploads",
	[PAGE.LAST]: "Teachers Remarks",
};

const STUDENT_REPORT_PAGES = [PAGE.SECOND, PAGE.THIRD, PAGE.FOURTH, PAGE.FIFTH, PAGE.SIXTH];

export const initialAddAttendanceModalFormState = {
	preparationStartTime: undefined,
	preparationEndTime: undefined,
	reportStartTime: undefined,
	reportEndTime: undefined,
};

export const MultipleTitleMapper = (students) => [
	"Lesson Details",
	...(
		students?.map((student, i) =>
			STUDENT_REPORT_PAGES.map((j) => `${TitleMapper[j]} (${student.studentDetail?.firstName} ${student.studentDetail?.lastName})`)
		) || []
	).flat(),
	"Teachers Remarks",
];

export const PageMapper = {
	[PAGE.FIRST]: ({ props }) => <FirstPage {...props} />,
	[PAGE.SECOND]: ({ props, student, studentPrefix }) => <SecondPage {...props} student={student} studentPrefix={studentPrefix} />,
	[PAGE.THIRD]: ({ props, student, studentPrefix }) => <ThirdPage {...props} student={student} studentPrefix={studentPrefix} />,
	[PAGE.FOURTH]: ({ props, student, studentPrefix }) => <FourthPage {...props} student={student} studentPrefix={studentPrefix} />,
	[PAGE.FIFTH]: ({ props, student, studentPrefix }) => <FifthPage {...props} student={student} studentPrefix={studentPrefix} />,
	[PAGE.SIXTH]: ({ props, student, studentPrefix }) => <SixthPage {...props} student={student} studentPrefix={studentPrefix} />,
	[PAGE.LAST]: ({ props, student, studentPrefix }) => <LastPage {...props} student={student} studentPrefix={studentPrefix} />,
};

export const renderPage = (props) => [
	<FirstPage {...props} />,
	...(props?.students?.map((student, i) => STUDENT_REPORT_PAGES.map((j) => PageMapper[j]({ props, student, studentPrefix: i }))) || []).flat(),
	<LastPage {...props} />,
];

const pageFields = {
	[PAGE.FIRST]: [
		"preparationStartTime",
		"preparationEndTime",
		"startTime",
		"endTime",
		"customLessonName",
		"reportStartTime",
		"reportEndTime",
		"urgentBonusProof",
	],
	[PAGE.SECOND]: (studentPrefix) => `studentReport.${studentPrefix}.traits`,
	[PAGE.THIRD]: (studentPrefix) => [`studentReport.${studentPrefix}.learningObjectives`],
	[PAGE.FOURTH]: (studentPrefix) => [`studentReport.${studentPrefix}.additionalComments`],
	[PAGE.FIFTH]: (studentPrefix) => [`studentReport.${studentPrefix}.classQuestions`],
	[PAGE.SIXTH]: (studentPrefix) => [
		`studentReport.${studentPrefix}.nonSubmitClassworkJustification`,
		`studentReport.${studentPrefix}.classworkImages`,
		// `studentReport.${studentPrefix}.inClassImages`,
	],
	[PAGE.LAST]: () => ["teachersRemark"],
};

export const useCheckValid = (trigger) => async (page, studentPrefix) => {
	const arr = [PAGE.FIRST];
	arr.push(PAGE.SECOND);
	arr.push(PAGE.THIRD);
	arr.push(PAGE.FOURTH);
	arr.push(PAGE.FIFTH);
	arr.push(PAGE.SIXTH);
	arr.push(PAGE.LAST);
	for (var i = 0; i < page / 4; i++) {
		arr.push(PAGE.SECOND);
		arr.push(PAGE.THIRD);
		arr.push(PAGE.FOURTH);
		arr.push(PAGE.FIFTH);
		arr.push(PAGE.LAST);
	}

	const derivedPage = arr[page];

	switch (derivedPage) {
		case PAGE.FIRST:
			return await trigger(pageFields[PAGE.FIRST]);
		case PAGE.SECOND:
			return await trigger(pageFields[PAGE.SECOND](studentPrefix));
		case PAGE.THIRD:
			return await trigger(pageFields[PAGE.THIRD](studentPrefix));
		case PAGE.FOURTH:
			return await trigger(pageFields[PAGE.FOURTH](studentPrefix));
		case PAGE.FIFTH:
			return await trigger(pageFields[PAGE.FIFTH](studentPrefix));
		case PAGE.SIXTH:
			return await trigger(pageFields[PAGE.SIXTH](studentPrefix));
		case PAGE.LAST:
			return await trigger(pageFields[PAGE.LAST](studentPrefix));
		default:
			throw new Error("invalid page");
	}
};

export const additionalCommentsQuestions = [
	{
		questionIndex: 0,
		question: "What were the concepts covered in class, and the student’s biggest takeaway from today’s class?",
	},
	{
		questionIndex: 1,
		question:
			"Describe the student’s attitude during class. How did the student feel before and after the class having satisfied the learning objectives?",
	},
	{
		questionIndex: 2,
		question: "How did the student validate themselves that they’ve successfully learnt today’s lesson objectives?",
	},
	{
		questionIndex: 3,
		question: "What academic advice would you give to the student? ",
	},
];
